import React, { useState } from 'react'
import {
  Table,
  TableBody,
  TableHead,
  TableContainer,
  Typography,
  MenuItem,
  Box,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import {
  StyledContainer,
  StyledTableCell,
  StyledTableRow,
  StyledSelect,
  StyledSearchField,
  StyledRefreshButton,
  StyledActionButton,
  StyledChip,
  StyledPaginationButton,
  HeaderBox,
  SearchBox,
  PaginationBox,
  StyledPaginationText,
  Head1,
  Head2,
  HeadBox,
  HeadBox1,
  Head3,
  Head4,
  MainTableBox,
  TableRowHead,
} from './Style'
import { Icons } from 'constants/icon'

interface PlatformData {
  platform: string
  icon: string
  volume: string
  volumeChange: 'up' | 'down'
  first: string
  firstCount: string
  second: string
  third: string
  fourth: string
  related: string
}

const mockData: PlatformData[] = [
  {
    platform: 'Instagram',
    icon: Icons.insta,
    volume: '152k',
    volumeChange: 'up',
    first: '#dogs',
    firstCount: '68k',
    second: '#pups',
    third: '#puppies',
    fourth: '#hatsonpups',
    related: 'cats',
  },
  {
    platform: 'Facebook',
    icon: Icons.facebook,
    volume: '112k',
    volumeChange: 'down',
    first: '#diggity',
    firstCount: '52k',
    second: '#doges',
    third: '#pets',
    fourth: '#dogsunder',
    related: 'rescues',
  },
  {
    platform: 'TikTok',
    icon: Icons.tiktok,
    volume: '221k',
    volumeChange: 'up',
    first: '#dogs',
    firstCount: '101k',
    second: '#dogey',
    third: '#sillydog',
    fourth: '#pets',
    related: 'cats',
  },
  {
    platform: 'YouTube',
    icon: Icons.youtube,
    volume: '87k',
    volumeChange: 'down',
    first: '#crazydogs',
    firstCount: '34k',
    second: '#petsgonewild',
    third: '#pets',
    fourth: '#doges',
    related: 'bunnies',
  },
  {
    platform: 'Reddit',
    icon: Icons.reddit,
    volume: '42k',
    volumeChange: 'up',
    first: '#doggies',
    firstCount: '18k',
    second: '#golden',
    third: '#doxen',
    fourth: '#retriever',
    related: 'cats',
  },
]

export default function Popularity(): JSX.Element {
  const [entriesCount, setEntriesCount] = useState<number>(10)

  const handleEntriesChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setEntriesCount(Number(event.target.value))
  }

  return (
    <>
      <StyledContainer>
        <HeadBox>
          <Head1>
            <Head2>Dogs</Head2>
          </Head1>
        </HeadBox>
        <HeadBox1>
          <Head3>
            <Head4>popularity threshold ▼</Head4>
          </Head3>
        </HeadBox1>
        <MainTableBox sx={{ mb: 5 }}>
          <HeaderBox>
            <Typography>Show</Typography>
            <StyledSelect
              size="small"
              value={entriesCount}
              //   onChange={handleEntriesChange}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </StyledSelect>
            <Typography>entries</Typography>
            <SearchBox>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <SearchIcon sx={{ ml: 1, mr: 1, color: '#ffffff' }} />
                <StyledSearchField size="small" placeholder="Search..." />
              </Box>
            </SearchBox>
            <StyledRefreshButton variant="contained">
              Refresh
            </StyledRefreshButton>
          </HeaderBox>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRowHead>
                  <StyledTableCell>Platform</StyledTableCell>
                  <StyledTableCell>Volume</StyledTableCell>
                  <StyledTableCell>First</StyledTableCell>
                  <StyledTableCell>Second</StyledTableCell>
                  <StyledTableCell>Third</StyledTableCell>
                  <StyledTableCell>Fourth</StyledTableCell>
                  <StyledTableCell>Related</StyledTableCell>
                  <StyledTableCell>Action</StyledTableCell>
                </TableRowHead>
              </TableHead>
              <TableBody>
                {mockData.map((row) => (
                  <StyledTableRow key={row.platform}>
                    <StyledTableCell>
                      <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 4 }}
                      >
                        <img
                          src={row.icon}
                          alt={row.platform}
                          width={16}
                          height={16}
                        />
                        {row.platform}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                      >
                        {row.volume}
                        {row.volumeChange === 'up' ? (
                          <img
                            src={Icons.gTopArrow}
                            alt="gTopArrow"
                            width={20}
                            height={20}
                          />
                        ) : (
                          <img
                            src={Icons.oDownArrow}
                            alt="oDownArrow"
                            width={20}
                            height={20}
                          />
                        )}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>{`${row.first} ${row.firstCount}`}</StyledTableCell>
                    <StyledTableCell>{row.second}</StyledTableCell>
                    <StyledTableCell>{row.third}</StyledTableCell>
                    <StyledTableCell>{row.fourth}</StyledTableCell>
                    <StyledTableCell>
                      <StyledChip label={row.related} size="small" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <StyledActionButton className="edit" size="small">
                        <img
                          src={Icons.edit}
                          alt="edit"
                          width={20}
                          height={20}
                        />
                      </StyledActionButton>
                      <StyledActionButton className="delete" size="small">
                        <img
                          src={Icons.delete}
                          alt="delete"
                          width={20}
                          height={20}
                        />
                      </StyledActionButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <PaginationBox>
            <StyledPaginationText className="inactive">
              Previous
            </StyledPaginationText>
            <StyledPaginationButton className="active" variant="contained">
              1
            </StyledPaginationButton>
            <StyledPaginationButton className="inactive">
              2
            </StyledPaginationButton>
            <StyledPaginationButton className="inactive">
              3
            </StyledPaginationButton>
            <StyledPaginationText className="inactive">
              Next
            </StyledPaginationText>
          </PaginationBox>
        </MainTableBox>

        <HeadBox>
          <Head1>
            <Head2>Puppies</Head2>
          </Head1>
        </HeadBox>
        <HeadBox1>
          <Head3>
            <Head4>popularity threshold ▼</Head4>
          </Head3>
        </HeadBox1>
        <MainTableBox sx={{ mb: 5 }}>
          <HeaderBox>
            <Typography>Show</Typography>
            <StyledSelect
              size="small"
              value={entriesCount}
              //   onChange={handleEntriesChange}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </StyledSelect>
            <Typography>entries</Typography>
            <SearchBox>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <SearchIcon sx={{ ml: 1, mr: 1, color: '#ffffff' }} />
                <StyledSearchField size="small" placeholder="Search..." />
              </Box>
            </SearchBox>
            <StyledRefreshButton variant="contained">
              Refresh
            </StyledRefreshButton>
          </HeaderBox>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRowHead>
                  <StyledTableCell>Platform</StyledTableCell>
                  <StyledTableCell>Volume</StyledTableCell>
                  <StyledTableCell>First</StyledTableCell>
                  <StyledTableCell>Second</StyledTableCell>
                  <StyledTableCell>Third</StyledTableCell>
                  <StyledTableCell>Fourth</StyledTableCell>
                  <StyledTableCell>Related</StyledTableCell>
                  <StyledTableCell>Action</StyledTableCell>
                </TableRowHead>
              </TableHead>
              <TableBody>
                {mockData.map((row) => (
                  <StyledTableRow key={row.platform}>
                    <StyledTableCell>
                      <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 4 }}
                      >
                        <img
                          src={row.icon}
                          alt={row.platform}
                          width={16}
                          height={16}
                        />
                        {row.platform}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                      >
                        {row.volume}
                        {row.volumeChange === 'up' ? (
                          <img
                            src={Icons.gTopArrow}
                            alt="gTopArrow"
                            width={20}
                            height={20}
                          />
                        ) : (
                          <img
                            src={Icons.oDownArrow}
                            alt="oDownArrow"
                            width={20}
                            height={20}
                          />
                        )}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>{`${row.first} ${row.firstCount}`}</StyledTableCell>
                    <StyledTableCell>{row.second}</StyledTableCell>
                    <StyledTableCell>{row.third}</StyledTableCell>
                    <StyledTableCell>{row.fourth}</StyledTableCell>
                    <StyledTableCell>
                      <StyledChip label={row.related} size="small" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <StyledActionButton className="edit" size="small">
                        <img
                          src={Icons.edit}
                          alt="edit"
                          width={20}
                          height={20}
                        />
                      </StyledActionButton>
                      <StyledActionButton className="delete" size="small">
                        <img
                          src={Icons.delete}
                          alt="delete"
                          width={20}
                          height={20}
                        />
                      </StyledActionButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <PaginationBox>
            <StyledPaginationText className="inactive">
              Previous
            </StyledPaginationText>
            <StyledPaginationButton className="active" variant="contained">
              1
            </StyledPaginationButton>
            <StyledPaginationButton className="inactive">
              2
            </StyledPaginationButton>
            <StyledPaginationButton className="inactive">
              3
            </StyledPaginationButton>
            <StyledPaginationText className="inactive">
              Next
            </StyledPaginationText>
          </PaginationBox>
        </MainTableBox>

        <HeadBox>
          <Head1>
            <Head2>animals</Head2>
          </Head1>
        </HeadBox>
        <HeadBox1>
          <Head3>
            <Head4>popularity threshold ▼</Head4>
          </Head3>
        </HeadBox1>
        <MainTableBox sx={{ mb: 5 }}>
          <HeaderBox>
            <Typography>Show</Typography>
            <StyledSelect
              size="small"
              value={entriesCount}
              //   onChange={handleEntriesChange}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </StyledSelect>
            <Typography>entries</Typography>
            <SearchBox>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <SearchIcon sx={{ ml: 1, mr: 1, color: '#ffffff' }} />
                <StyledSearchField size="small" placeholder="Search..." />
              </Box>
            </SearchBox>
            <StyledRefreshButton variant="contained">
              Refresh
            </StyledRefreshButton>
          </HeaderBox>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRowHead>
                  <StyledTableCell>Platform</StyledTableCell>
                  <StyledTableCell>Volume</StyledTableCell>
                  <StyledTableCell>First</StyledTableCell>
                  <StyledTableCell>Second</StyledTableCell>
                  <StyledTableCell>Third</StyledTableCell>
                  <StyledTableCell>Fourth</StyledTableCell>
                  <StyledTableCell>Related</StyledTableCell>
                  <StyledTableCell>Action</StyledTableCell>
                </TableRowHead>
              </TableHead>
              <TableBody>
                {mockData.map((row) => (
                  <StyledTableRow key={row.platform}>
                    <StyledTableCell>
                      <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 4 }}
                      >
                        <img
                          src={row.icon}
                          alt={row.platform}
                          width={16}
                          height={16}
                        />
                        {row.platform}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                      >
                        {row.volume}
                        {row.volumeChange === 'up' ? (
                          <img
                            src={Icons.gTopArrow}
                            alt="gTopArrow"
                            width={20}
                            height={20}
                          />
                        ) : (
                          <img
                            src={Icons.oDownArrow}
                            alt="oDownArrow"
                            width={20}
                            height={20}
                          />
                        )}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell>{`${row.first} ${row.firstCount}`}</StyledTableCell>
                    <StyledTableCell>{row.second}</StyledTableCell>
                    <StyledTableCell>{row.third}</StyledTableCell>
                    <StyledTableCell>{row.fourth}</StyledTableCell>
                    <StyledTableCell>
                      <StyledChip label={row.related} size="small" />
                    </StyledTableCell>
                    <StyledTableCell>
                      <StyledActionButton className="edit" size="small">
                        <img
                          src={Icons.edit}
                          alt="edit"
                          width={20}
                          height={20}
                        />
                      </StyledActionButton>
                      <StyledActionButton className="delete" size="small">
                        <img
                          src={Icons.delete}
                          alt="delete"
                          width={20}
                          height={20}
                        />
                      </StyledActionButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <PaginationBox>
            <StyledPaginationText className="inactive">
              Previous
            </StyledPaginationText>
            <StyledPaginationButton className="active" variant="contained">
              1
            </StyledPaginationButton>
            <StyledPaginationButton className="inactive">
              2
            </StyledPaginationButton>
            <StyledPaginationButton className="inactive">
              3
            </StyledPaginationButton>
            <StyledPaginationText className="inactive">
              Next
            </StyledPaginationText>
          </PaginationBox>
        </MainTableBox>
      </StyledContainer>
    </>
  )
}
